<script setup>
import { useSlots } from 'vue';
import PopperCustom from '@/components/PopperCustom.vue';
const {
  title,
  subTitle,
  customWidth,
  popper,
  hasPopper,
  customPadding,
  showContent,
} = defineProps({
  title: {
    type: String,
    required: false,
    default: '',
  },
  subTitle: {
    type: String,
    required: false,
    default: '',
  },
  customWidth: {
    type: String,
    required: false,
    default: 'w-full',
  },
  customHeight: {
    type: String,
    required: false,
    default: 'h-full',
  },
  customGap: {
    type: String,
    required: false,
    default: 'gap-10',
  },
  customPadding: {
    type: String,
    required: false,
    default: 'p-4',
  },
  hasPopper: {
    type: Boolean,
    required: false,
    default: false,
  },
  popper: {
    type: Object,
    required: false,
    default: () => ({
      title: 'Popper Title',
      description: 'Popper Description',
    }),
  },
  isAccordion: {
    type: Boolean,
    required: false,
    default: false,
  },
  showContent: {
    type: Boolean,
    required: false,
    default: true,
  },
});
const slots = useSlots();
defineEmits(['headerClick']);
</script>

<template>
  <div
    class="flex flex-col items-center justify-start gap-3 overflow-hidden rounded-xl bg-white shadow-md outline outline-1 outline-offset-[-1px] outline-neutral-300-a"
    :class="[customWidth, customHeight, customGap, customPadding]"
  >
    <div
      class="flex w-full items-center justify-between gap-4"
      :class="[{ 'cursor-pointer p-4 hover:bg-steel-100': isAccordion }]"
      @click="$emit('headerClick')"
    >
      <div class="flex gap-2">
        <div class="flex flex-col justify-center gap-1">
          <div class="flex items-center gap-1">
            <div
              class="text-xl font-medium leading-normal tracking-tight text-steel-1100"
            >
              {{ title }}
            </div>
            <PopperCustom
              v-if="hasPopper"
              :colorScheme="dark"
              size="sm"
              contentWidthClass="text-center max-w-44 p-2"
              placement="bottom"
            >
              <template v-slot:icon>
                <span
                  class="text-info-subtle-text flex h-8 flex-shrink-0 items-center justify-center rounded-full hover:text-dark-gray"
                >
                  <svg
                    width="22"
                    height="17"
                    viewBox="0 0 22 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M22 8.39062C22 12.2566 18.866 15.3906 15 15.3906C11.134 15.3906 8 12.2566 8 8.39062C8 4.52463 11.134 1.39062 15 1.39062C18.866 1.39062 22 4.52463 22 8.39062ZM13.9999 7.99616V13.3496H15.9999V7.99616H13.9999ZM13.9999 6.08456V3.87133H15.9999V6.08456H13.9999Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </template>
              <template v-slot:content>
                <div class="text-xs leading-5">
                  {{ popper.description }}
                </div>
              </template>
            </PopperCustom>
          </div>
          <div
            v-if="subTitle"
            class="text-sm font-normal text-steel-900"
          >
            {{ subTitle }}
          </div>
        </div>
      </div>
      <div class="flex items-center">
        <slot name="rightHeader"></slot>
      </div>
    </div>
    <div
      v-if="slots?.content && showContent"
      class="w-full min-w-0 overflow-x-auto"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style scoped></style>
